import { createSlice } from '@reduxjs/toolkit';
import { otpVerificationApi } from '../../../rtk-apis/auth/otpVerification';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
};

const otpVerificationSlice = createSlice({
  name: 'otpVerification',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(otpVerificationApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(otpVerificationApi.fulfilled, (state, action) => {
        console.log(action);
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
      })
      .addCase(otpVerificationApi.rejected, (state, action) => {
        console.log(action);
        state.loading = false;
        state.status = 'ERROR';
        state.msg = action?.payload?.msg ?? 'Something went wrong';
      });
  },
});

export default otpVerificationSlice.reducer;
export const { clearState } = otpVerificationSlice.actions;
